import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { User } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { UserRolesForm } from './user-roles-form';
import { UserUserGroupsForm } from './user-user-groups-form';
import { UserDetailsForm, UserPermissionsPage } from '.';

export function UserPage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [user, setUser] = useState<User>();

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadUser = useCallback(() => {
    apiClient
      .get(`users/${id}`)
      .then((response: any) => {
        setUser(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  useEffect(() => {
    if (!id) {
      return;
    }
    loadUser();
  }, [id, loadUser]);

  const TabContent = (props: any) => {
    return <Content style={{ backgroundColor: '#fff' }}>{props.children}</Content>;
  };

  return (
    <>
      <PageHeader title="Kullanıcı düzenle" subTitle={user?.fullName} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <Row>
                <Col span={8} xs={24} sm={24} md={12} lg={10} xl={10} xxl={8}>
                  <UserDetailsForm user={user} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanıcı grupları (yeni)" key="user-groups">
            <TabContent>
              <Row>
                <Col span={16} xs={24} sm={24} md={24} lg={20} xl={20} xxl={16}>
                  <UserUserGroupsForm user={user} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Roller (yeni)" key="roles">
            <TabContent>
              <UserRolesForm user={user} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Yetkiler (yeni)" key="permissions">
            <TabContent>
              <UserPermissionsPage user={user} />
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
